import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconPlaylistAddCheck.tsx
const OutlinedFilledPlaylistAddCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M103-303v-95h323v95H103Zm0-189v-94h484v94H103Zm0-188v-94h484v94H103Zm560 525L503-315l66-67 94 93 185-185 68 67-253 252Z" })
});
const OutlinedPlaylistAddCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M103-303v-95h323v95H103Zm0-189v-94h484v94H103Zm0-188v-94h484v94H103Zm560 525L503-315l66-67 94 93 185-185 68 67-253 252Z" })
});
const RoundedFilledPlaylistAddCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M150-303q-19.75 0-33.37-13.68Q103-330.35 103-351.18q0-19.82 13.63-33.32Q130.25-398 150-398h229q19.75 0 33.38 13.68Q426-370.65 426-350.82q0 20.82-13.62 34.32Q398.75-303 379-303H150Zm0-189q-19.75 0-33.37-13.68Q103-519.35 103-539.18q0-19.82 13.63-33.32Q130.25-586 150-586h390q19.75 0 33.38 13.68Q587-558.65 587-538.82q0 19.82-13.62 33.32Q559.75-492 540-492H150Zm0-188q-19.75 0-33.37-13.68Q103-707.35 103-727.18q0-19.82 13.63-33.32Q130.25-774 150-774h390q19.75 0 33.38 13.68Q587-746.65 587-726.82q0 19.82-13.62 33.32Q559.75-680 540-680H150Zm512.87 506q-8.87 0-17.37-3.5Q637-181 630-188l-94-94q-14-14-13.5-33.5T537-349q14-14 33.47-14 19.46 0 32.53 14l60 60 153-152q13.8-14 32.4-14 18.6 0 32.99 14 14.61 14 14.11 34T881-373L697-188q-7 7-15.63 10.5-8.64 3.5-18.5 3.5Z" })
});
const RoundedPlaylistAddCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M150-303q-19.75 0-33.37-13.68Q103-330.35 103-351.18q0-19.82 13.63-33.32Q130.25-398 150-398h229q19.75 0 33.38 13.68Q426-370.65 426-350.82q0 20.82-13.62 34.32Q398.75-303 379-303H150Zm0-189q-19.75 0-33.37-13.68Q103-519.35 103-539.18q0-19.82 13.63-33.32Q130.25-586 150-586h390q19.75 0 33.38 13.68Q587-558.65 587-538.82q0 19.82-13.62 33.32Q559.75-492 540-492H150Zm0-188q-19.75 0-33.37-13.68Q103-707.35 103-727.18q0-19.82 13.63-33.32Q130.25-774 150-774h390q19.75 0 33.38 13.68Q587-746.65 587-726.82q0 19.82-13.62 33.32Q559.75-680 540-680H150Zm512.87 506q-8.87 0-17.37-3.5Q637-181 630-188l-94-94q-14-14-13.5-33.5T537-349q14-14 33.47-14 19.46 0 32.53 14l60 60 153-152q13.8-14 32.4-14 18.6 0 32.99 14 14.61 14 14.11 34T881-373L697-188q-7 7-15.63 10.5-8.64 3.5-18.5 3.5Z" })
});
const SharpFilledPlaylistAddCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M103-303v-95h323v95H103Zm0-189v-94h484v94H103Zm0-188v-94h484v94H103Zm560 525L503-315l66-67 94 93 185-185 68 67-253 252Z" })
});
const SharpPlaylistAddCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M103-303v-95h323v95H103Zm0-189v-94h484v94H103Zm0-188v-94h484v94H103Zm560 525L503-315l66-67 94 93 185-185 68 67-253 252Z" })
});
const componentMap = {
	outlined: OutlinedPlaylistAddCheck,
	"outlined-fill": OutlinedFilledPlaylistAddCheck,
	rounded: RoundedPlaylistAddCheck,
	"rounded-fill": RoundedFilledPlaylistAddCheck,
	sharp: SharpPlaylistAddCheck,
	"sharp-fill": SharpFilledPlaylistAddCheck
};
const IconPlaylistAddCheck = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t("icon.playlistAddCheck"),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconPlaylistAddCheck };